




















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { Upload } from '@ss/mtd-vue';
@Component
export default class ImportModal extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop({ default: null })
    timestamp: Date;
    @Prop({ default: false })
    showCloseReasonImportModal: boolean;

    showModal: boolean = false;
    templateBtnLoading: boolean = false;
    submitBtnLoading: boolean = false;
    submitBtnDisabled: boolean = true;
    showValidateMsg: boolean = false;
    fileLink: string = '';
    objectName: string = '';
    uploadHint: string = '';
    validateStatus: 'success' | 'error' = 'error';
    $refs: { archiveUpload: Upload };

    get uploadAction() {
        if (this.showCloseReasonImportModal) {
            return `/api/cti/1.0/archive/close/reason/import?rgId=${this.rgId}`;
        } else {
            return `/api/cti/1.0/archive/import?rgId=${this.rgId}`;
        }
    }

    get modalTitle() {
        return this.showCloseReasonImportModal ? '导入关联关闭原因' : '导入问题归档';
    }

    get downloadButtonText() {
        return this.showCloseReasonImportModal ? '下载关联关闭原因模板' : '下载问题归档模板';
    }

    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
    }
    cancel() {
        this.$emit('update:visible', false);
    }
    async confirm() {
        this.submitBtnLoading = true;
        try {
            this.$refs.archiveUpload.submit();
        } catch (error) {
            this.submitBtnLoading = false;
            console.log(error);
        }
    }
    async createExportTask() {
        if (this.showCloseReasonImportModal) {
            try {
                const res = await api.ctiApi.exportCloseReason(this.rgId);
                const { data, code } = res;
                if (code === 200 && data) {
                    this.templateBtnLoading = false;
                    this.$mtd.message.success(data);
                }
            } catch (error) {
                this.templateBtnLoading = false;
                console.log(error);
            }
        } else {
            try {
                const res = await api.ctiApi.getArchiveExportTemplate(this.rgId);
                const { data, code } = res;
                if (code === 200 && data) {
                    this.templateBtnLoading = false;
                    this.$mtd.message.success(data);
                }
            } catch (error) {
                this.templateBtnLoading = false;
                console.log(error);
            }
        }
    }
    beforeUpload(file) {
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            this.$mtd.message.error('上传文件大小不能超过 10MB');
        }
        return isLt10M;
    }
    handleUploadSuccess(res) {
        if (!res.data.success) {
            this.showValidateMsg = true;
            this.uploadHint = res.data.message || '上传失败请重试';
            this.submitBtnLoading = false;
            // 上传出错后不允许再次点击按钮
            this.submitBtnDisabled = true;
        } else {
            this.submitBtnLoading = false;
            this.$mtd.message.success(res.data.message || '导入成功');
            this.cancel();
        }
    }
    handleUploadError() {
        this.submitBtnLoading = false;
        this.$mtd.message.error('上传失败，请重试');
    }
    handleExceed() {
        this.$mtd.message.error('仅允许上传一个文件，请删除后重新上传');
    }
    handelFileRemove() {
        this.showValidateMsg = false;
        this.submitBtnDisabled = true;
    }
    handleFileChanged(file, fileList) {
        if (this.showValidateMsg) return;
        this.submitBtnDisabled = !fileList.length;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
